export function formatMoney(value) {
  if (value === null || value === undefined) return '-'
  return Number(value).toFixed(6).replace(/0+$/, '').replace(/\.$/, '')
}

export function formatNumber(value) {
  if (value === null || value === undefined) return '-'
  return Number(value).toLocaleString('zh-CN')
}

export function formatTokens(value) {
  if (value === null || value === undefined) return '-'
  const n = Number(value)
  if (n >= 10000) {
    return (n / 10000).toFixed(2).replace(/\.?0+$/, '') + '万'
  }
  return '' + n
}

export function formatTime(value) {
  if (!value) return '-'
  const t = new Date(value)
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())} ${pad(t.getHours())}:${pad(t.getMinutes())}:${pad(t.getSeconds())}`
}